import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useMenuItemStyles } from './index.style';
import { MenuItem } from 'menu-items/type';
import { useNavigate } from 'react-router-dom';

interface IHookProps {
  data: MenuItem;
}

const CMP: React.FC<IHookProps> = ({ data }) => {
  const { t, i18n } = useTranslation(['menu']);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [isActive, setIsActive] = useState<boolean>(false);
  const { styles } = useMenuItemStyles({
    isActive
  });

  useEffect(() => {
    if (data.url === pathname || (pathname === '/' && data.url === '/dashboard')) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [data.url, pathname]);

  const goPage = () => {
    if (data.fn) {
      data.fn(i18n.language);
      return;
    }
    if (!data.url) return;
    navigate(data.url);
  };

  const Icon = data.icon;
  return (
    <div className={styles.menuItem} key={data.title} onClick={goPage}>
      {Icon ? <Icon /> : null}
      <div className={styles.subMenuTitle}>{t(data.i18nTitle || '', { ns: 'menu' })}</div>
    </div>
  );
};

export default CMP;
